import { invert } from "lodash"

export enum AvailabilityCalcTypes {
  FULL = 1,
  NET = 2,
}

export enum EfficiencyCalcTypes {
  AMOUNT = 1,
  TIME = 2,
}

export const AvailabilityCalcNames = invert(AvailabilityCalcTypes)
export const EfficiencyCalcNames = invert(EfficiencyCalcTypes)
